import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityService } from '@app-lib';

// import getMAC, { isMAC } from 'getmac'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  collapse: boolean = false;
  constructor(private _security: SecurityService, private _router: Router) {}
  ngOnInit(): void {
    //onsole.log(getMAC())

    // su reload riprende i diritti FDU
    this._security.AppInitAllDirittiFDU().subscribe((r: string) => {
      //onsole.log('-AppComponent-->' + JSON.stringify(r, null, 4));
      if (r == 'login') {
        this._router.navigate(['/auth/login']);
      }
    });
    this._security.StoreLogo();
  }
}
